// import React from "react";

// import { CopyToClipboard } from "react-copy-to-clipboard";
// import Tooltip from "@mui/material/Tooltip";

// type Props = {
//   tooltipTitle: string;
//   copyText: string;
//   children: React.ReactNode;
//   onCopy?: () => void;
// };

// const ATMCopyToClipboard = ({
//   tooltipTitle,
//   copyText,
//   children,
//   onCopy,
// }: Props) => {
//   return (
//     <Tooltip title={tooltipTitle}>
//       <div className='cursor-pointer'>

//         // @ts-expect-error
//         <CopyToClipboard text={copyText} onCopy={onCopy}>
//           {children}
//         </CopyToClipboard>
//       </div>
//     </Tooltip>
//   );
// };

// export default ATMCopyToClipboard;

import React, { ReactNode } from "react";

interface ClipboardProps {
  copyText: string;
  onCopy?: () => void;
  children: ReactNode;
  tooltipTitle?: string;
}

const ATMCopyToClipboard: React.FC<ClipboardProps> = ({
  copyText,
  onCopy,
  children,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      onCopy?.();
    } catch (err) {
      console.error("Clipboard copy failed", err);
    }
  };

  return (
    <div onClick={handleCopy} className="cursor-pointer">
      {children}
    </div>
  );
};

export default ATMCopyToClipboard;
